import { createEntityAdapter } from '@reduxjs/toolkit'
import type { SlideState } from './types'

export const slidesAdapter = createEntityAdapter<SlideState>()
